import React, { useState, useEffect, useCallback } from "react";
import { useIntl } from "react-intl";
import { Row, Col } from "antd";

import { isUserReader } from "../../modules/session";
import { warningModal } from "../../modules/messages";
import { useUserRole } from "../../modules/redux/session/useAuth";
import { deleteEntity, getEntities } from "../../modules/crudOperations";
import { parsePhone, parseStreet } from "../../modules/consignmentFunctions";
import AddressListTable from "../../components/addressList/addressListTable";
import AddressListFilter from "../../components/addressList/addressListFilter";
import AddressListHeader from "../../components/addressList/addressListHeader";

function AddressList() {
  const intl = useIntl();
  const [workAddresses, setWorkAddresses] = useState([]);
  const [selectedAddresses, setSelectedAddresses] = useState([]);

  const [addresses, setAddresses] = useState();
  const loadAddresses = useCallback(
    (parameters) => {
      setSelectedAddresses([]);
      getEntities(
        "address",
        setAddresses,
        (a) => ({
          key: a.id,
          address: a,
          name: a.name || "--",
          street: parseStreet(a),
          city: a.city || "--",
          zipCode: a.zipCode || "--",
          country: (a.country && a.country.code) || "--",
          contactPerson: a.contactPerson || "--",
          contactPhone: parsePhone(a),
          contactEmail: a.contactEmail || "--",
        }),
        { ...parameters, addressType: "dl;in;pc" },
      );
    },
    [setSelectedAddresses],
  );

  const handleDeleteClick = useCallback(() => {
    if (selectedAddresses && selectedAddresses.length > 0) {
      deleteEntity(
        `address/bulk?${selectedAddresses
          .filter((c) => c.length !== 11)
          .map((c) => `ids=${c}`)
          .join("&")}`,
        "",
        intl.formatMessage({
          id: "customer.multiple",
          defaultMessage: "Zákazníci",
        }),
        intl.formatMessage({
          id: "customer.genitivMultiple",
          defaultMessage: "zákazníků",
        }),
        () =>
          setAddresses(
            addresses.filter((a) => !selectedAddresses.includes(a.key)),
          ),
        false,
        "i",
      );
    } else {
      warningModal(
        intl.formatMessage(
          {
            id: "consignment.dropConsignments.noConsignments",
            defaultMessage:
              "Nemáte označené žádné {entity} pro smazání, označte prosím nějaké!",
          },
          {
            entity: intl.formatMessage({
              id: "customer.exportWhom",
              defaultMessage: "zákazníky",
            }),
          },
        ),
      );
    }
    setSelectedAddresses([]);
  }, [intl, addresses, selectedAddresses]);

  const [allSelected, setAllSelected] = useState(false);
  const handleSelectClick = useCallback(() => {
    if (addresses && addresses.length > 0) {
      setSelectedAddresses(allSelected ? [] : addresses.map((a) => a.key));
    }
  }, [addresses, allSelected]);

  const [showFilter, setShowFilter] = useState();
  const handleFilterClick = useCallback(() => {
    setShowFilter(!showFilter);
  }, [showFilter]);

  const reader = isUserReader(useUserRole());

  useEffect(() => {
    addresses &&
      addresses !== "e" &&
      setWorkAddresses(
        addresses.filter((a) => selectedAddresses.includes(a.key)),
      );
  }, [addresses, selectedAddresses]);

  useEffect(() => {
    setAllSelected(
      addresses &&
        addresses.length > 0 &&
        selectedAddresses.length === addresses.length,
    );
  }, [addresses, selectedAddresses]);

  return (
    <Row>
      <Col>
        <AddressListHeader
          addresses={addresses}
          showFilter={showFilter}
          disabledOptions={reader}
          allSelected={allSelected}
          workAddresses={workAddresses}
          onDeleteClick={handleDeleteClick}
          onFilterClick={handleFilterClick}
          onSelectClick={handleSelectClick}
        />
        <AddressListFilter
          showFilter={showFilter}
          loadAddresses={loadAddresses}
          onSetShowFilter={setShowFilter}
        />
        <AddressListTable
          addresses={addresses}
          loadAddresses={loadAddresses}
          selectedAddresses={selectedAddresses}
          setSelectedAddresses={setSelectedAddresses}
        />
      </Col>
    </Row>
  );
}

export default AddressList;
